module.exports = __webpack_public_path__ + "static/img/002.7495af3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/honor/awards/002.png
// module id = XzKS
// module chunks = 0